import React, { memo } from "react";
import Notification from "@components/Notification";
import RenderTitle from "@components/layouts/RenderTitle";
import Search from "./Search";
import LangChange from "./LangChange";
import BurgerMenuIcon from "public/images/global/BurgerMenuIcon";
import { useDispatch, useSelector } from "noval";
import { Icon } from "@utils/helper";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { buildClass, checkClass } from "@utils/tag";
import {
  useIntercomListener,
  useIntercomToggle,
} from "Hooks/redirectionHelperHooks";

const NavBar = ({ fromSlide }) => {
  const [supportOpen, screen] = useSelector(["supportOpen", "screen"], [false]);
  const { dispatch } = useDispatch();
  const { pathname } = useRouter();
  const { t, lang } = useTranslation();
  const { intercom_toggler, loadingIntercom } = useIntercomToggle(lang);

  useIntercomListener(supportOpen);

  return (
    <div
      className={buildClass(
        "flex justify-between items-start lg:items-center",
        { "flex-col gap-3 lg:flex-row lg:gap-": pathname === "/home" },
        { "p-2 rounded-xl": fromSlide }
      )}
    >
      {!fromSlide && (
        <div className="flex items-center gap-3">
          <div
            className="xl:hidden h-[43px] w-[43px] flex justify-center items-center cursor-pointer"
            onClick={() => dispatch({ openDrawer: true })}
          >
            <BurgerMenuIcon height={30} width={30} itemHeight={4} />
          </div>
          <RenderTitle />
        </div>
      )}
      <div
        className={buildClass(
          "flex justify-between items-center gap-5",
          { "p-4 md:p-0 rounded-xl md:rounded-none": pathname === "/home" },
          checkClass(fromSlide, [
            "!flex-col !bg-gradient-to-r from-[#FFFFFF73] to-[#FFFFFF30]",
          ])
        )}
      >
        {pathname === "/home" && <Search />}
        <div className="flex justify-around items-center gap-5 md:gap-2 w-full md:w-auto px-1">
          {!fromSlide && <Notification />}
          <IntercomButton
            clickCallBack={intercom_toggler}
            loading={loadingIntercom}
            supportOpen={supportOpen}
            screen={screen}
            t={t}
          />
          <div className="flex justify-center items-center relative">
            <LangChange iconWhite={screen === "sm-phone"} />
          </div>
        </div>
      </div>
    </div>
  );
};

const IntercomButton = ({ clickCallBack, loading, supportOpen, screen, t }) => (
  <Tooltip title={t("nav.intercom_boot")}>
    <IconButton
      onClick={clickCallBack}
      size="small"
      aria-controls={supportOpen ? "account-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={supportOpen ? "true" : undefined}
    >
      <div
        className={buildClass(
          "w-[43px] h-[43px] rounded-[36px] flex justify-center items-center cursor-pointer",
          checkClass(supportOpen, ["bg-[#0366FF]", "bg-[#F3F5F8]"]),
          { "!bg-[rgba(255,255,255,.3)]": screen === "sm-phone" }
        )}
      >
        {loading ? (
          <CircularProgress
            size={15}
            sx={{ color: supportOpen ? "#F3F5F8" : "#0366FF" }}
          />
        ) : (
          <Icon
            id="r4-c23"
            className={
              supportOpen
                ? "text-white"
                : screen === "sm-phone"
                ? "text-white"
                : "text-[#333]"
            }
          />
        )}
      </div>
    </IconButton>
  </Tooltip>
);

export default memo(NavBar);
